module.exports = __webpack_public_path__ + "src/assets/img/visual_spotted-pattern.49ed8913.jpg";